import {Label} from 'platform/components';
import {Box, Show, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {AuctionVehicleDetailResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useApiEnums} from '../../../hooks/useApiEnums';
import {buildLocationDetail, buildLocationName} from '../utils/buildLocationName';

interface AuctionPickupPointProps extends TestIdProps {
  auction: AuctionVehicleDetailResponseBody;
}

export function AuctionPickupPoint(props: AuctionPickupPointProps) {
  const {getEnum} = useApiEnums();
  const seller = props.auction.auctionVehicle.seller;
  const rawCountry = props.auction.auctionVehicle.sellerCountry;
  const countryName = getEnum('country').find(({key}) => key === rawCountry)?.label ?? rawCountry;

  if (isNil(seller) || (isNil(seller.address) && isNil(seller.city))) {
    return null;
  }

  const locationName = buildLocationName(seller.address, seller.city);
  const hasDetail = isNotNil(seller.zip) || isNotNil(rawCountry);
  const locationDetail = buildLocationDetail(seller.zip, countryName);

  return (
    <Box padding={4} backgroundColor="palettes.neutral.20.100" borderRadius="small">
      <VStack spacing={1}>
        <Label data-testid={suffixTestId('pickupPointLabel', props)}>
          {i18n.t('entity.auction.labels.pickupPoint')}
        </Label>
        <Text alternative data-testid={suffixTestId('locationName', props)}>
          {locationName}
        </Text>
        <Show when={hasDetail}>
          <Text size="small" color="secondary" data-testid={suffixTestId('locationDetail', props)}>
            {locationDetail}
          </Text>
        </Show>
      </VStack>
    </Box>
  );
}
